export default "__VITE_ASSET__DxRBSUiE__"